/* Helpers for the Yesplan search query language, shared by the client and the
 * server: both build queries - the client for the events list, the server for
 * the /resourcebookings route - and the format below has to match on both
 * sides or a query silently selects the wrong dates.
 *
 * Imported by app/ (bundled by webpack) and by server/ (compiled by babel to
 * dist/shared, see the "bundle" script). Keep it dependency-free apart from
 * moment, so it stays importable from both runtimes: no React, no i18n, no
 * express, nothing browser-only.
 */
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';

/* The date format the query language expects, e.g. 'date:25-08-2026' */
const queryDateFormat = 'DD-MM-YYYY';

/* The date of a query, from either a date object or a plain 'YYYY-MM-DD'
   string. Both are formatted in local time and a date-only string parses as
   local midnight, so neither shifts a day across timezones. */
export function inQueryLanguageDateFormat(dateObject) {
  return moment(dateObject).format(queryDateFormat);
}
